<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="main-content">
      <div class="content main">
        <div class="section-one">
          <ul class="content-list">
            <li v-for="(item,index) in project.list" :key="index">
              <a :title="item.name" href="javascript:;" @click="goDetail(item)">
                <span class="title">{{item.name}}</span>
                <span class="time">{{item.publish_date}}</span>
              </a>
            </li>
          </ul>
          <div class="page-bar fr">
            <el-pagination prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :page-size="project.page.limit" :total="project.page.total" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>

<script>
  import Vue from 'vue';
  import myHead from '../../components/myHead/myhead';
  import myFoot from '../../components/myFoot/myfoot';
  import common from '../../assets/js/utils/common';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";

  export default {
    name: "index",
    data() {
      return {
        project: {
          page: {
            limit: 7,
            total: 0,
            pages: 1,
            current: 1
          },
          list: []
        },
      }
    },
    components: {
      myHead,
      myFoot
    },
    mounted() {
      this.name = this.$route.query.name
      this.getSearchList()
    },
    computed: {
     
    },
    created() {
    },
    methods: {
      ...mapActions({
        getHomeSearch: "index/getHomeSearch",
      }),
      getSearchList(){
        this.getHomeSearch({
          data:{
            page:this.project.page.current,
            name:this.name
          },
          success:(res) => {
            if(res.code == 1){
              this.project = res.data
            }
          },
        })
      },
      handleCurrentChange(current){
        this.project.page.current = current
        this.getSearchList()
      },
      goDetail(item){
        var params = {id:item.id,s_type:item.s_type}
        var type = item.type
        var name = ''
        if(type == 1){
          name = 'bidding'
        }else if(type == 2){
          name = 'regulation'
        }else if(type == 3){
          name = 'platform'
        }
        this.$router.push({name: name,query: params})
      }
      
    }
  }
</script>

<style scoped>
  .banner {
    width: 1920px;
    margin: 0 auto;
  }
.main-content .main .section-one {
      margin-top: 40px;
      padding: 40px 0px 90px;
      background-color: #fff;
  }

  .main-content .main .section-one .content-list {
    min-height: 300px;
  }

  .main-content .main .section-one .content-list li {
    display: block;
    font-weight: 700;
    padding: 0 40px;
    /* border-bottom: 1px dashed rgba(0, 0, 0, .2); */
  }

  .main-content .main .section-one .content-list li>a {
    display: inline-block;
    width: 100%;
    line-height: 55px;
    position: relative;
  }

  .main-content .main .section-one .content-list li>a:hover {
    color: #1969E5;
    background-color: #f6f6f6;
  }

  .main-content .main .section-one .content-list li .title {
    width: 100%;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 20px;
  }

  .main-content .main .section-one .content-list li .time {
    position: absolute;
    width: 15%;
    top: 0;
    right: 20px;
    color: #999;
    text-align: right;
  }

  .main-content .main .section-one .page-bar {
    position: relative;
    margin: 20px 0 20px;
    height: 32px;
  }

  /deep/.el-pagination button,
  .el-pagination span:not([class*=suffix]) {
    padding: 0 6px !important;
  }

  /deep/.el-pagination button:hover,
  .el-pagination span:hover {
    color: #409eff !important;
  }
</style>